import React from 'react'
import "./logoCard.css"
const LogoCard = () => {
  return (
   <div>
<ul class="wrapper1">
  <li class="icon facebook border border-white border-4">
    <span class="tooltip">Facebook</span>
    <svg

      viewBox="0 0 320 512"
      height="1.2em"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
      ></path>
    </svg>
  </li>
 
    `<a href="https://wa.link/xzd48l" target='_blank'>
  <li class="icon facebook border border-white ">
  <span class="tooltip">WhatsApp</span>
  <svg
    viewBox="0 0 448 512"
    height="1.2em"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M380.9 97.1C339 55.9 283.6 32 224 32 100.3 32 0 132.3 0 256c0 45.1 11.8 89.5 34.1 128.2L1.7 480l100.7-32.3c37.7 20.7 80.4 31.6 121.6 31.6h.1c123.7 0 224-100.3 224-224 0-59.6-23.9-115-67.1-158.9zM224.1 439.6h-.1c-37.4 0-75.4-10.2-107.7-29.5l-7.7-4.6-60.1 19.3 19.8-58.5-5-8c-21.4-34.3-32.8-73.9-32.8-114.6C30.5 150.1 118.6 62 224 62c48.5 0 94.2 18.9 128.6 53.4 34.4 34.4 53.3 80.2 53.3 128.6-.1 105.5-87.5 192.6-192.8 195.6zm101.7-138.1c-5.6-2.8-33-16.2-38.1-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.7-3.2 3.7-6.5 4.2-12.1 1.4-33.2-16.6-55-29.6-77.3-67.1-5.8-10 5.8-9.3 16.6-31 1.9-3.7 1-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.1-4.5-10.9-9.1-9.4-12.5-9.6-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.6-19.4 19-19.4 46.3s19.9 53.7 22.7 57.4c2.8 3.7 38.9 59.4 94.4 83.3 35.1 15.1 49 16.4 66.7 13.8 10.7-1.6 33-13.4 37.6-26.3 4.6-12.8 4.6-23.8 3.2-26.2-1.2-2.4-5.1-3.7-10.7-6.5z"
    ></path>
  </svg>
</li>
</a>`

<li class="icon facebook">
    <span class="tooltip">LinkedIn</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1.2em"
      fill="currentColor"
      viewBox="0 0 448 512"
    >
      <path
        d="M100.28 448H7.4V149.6h92.78zm-46.14-338.4c-30.58 0-55.31-24.72-55.31-55.3S23.56 0 54.14 0c30.6 0 55.3 24.72 55.3 55.3 0 30.58-24.7 55.3-55.3 55.3zm394.04 338.4h-92.68V302.4c0-34.7-12.4-58.4-43.6-58.4-23.8 0-38 16-44.2 31.5-2.3 5.6-2.8 13.5-2.8 21.4v151.1H172.2V149.6h89v40.7h1.3c12.4-20.2 34.4-49 83.7-49 61.1 0 106.8 39.8 106.8 125.4V448z"
      ></path>
    </svg>
  </li>

  
  <li class="icon youtube">
  <span class="tooltip">YouTube</span>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    fill="currentColor"
    viewBox="0 0 576 512"
  >
    <path
      d="M549.7 124.1c-6.3-24-24.9-42.6-48.9-48.9C456.5 64 288 64 288 64S119.5 64 75.3 75.2C51.3 81.5 32.7 100.1 26.4 124.1 16 168.3 16 256 16 256s0 87.7 10.4 131.9c6.3 24 24.9 42.6 48.9 48.9C119.5 448 288 448 288 448s168.5 0 212.7-11.2c24-6.3 42.6-24.9 48.9-48.9C560 343.7 560 256 560 256s0-87.7-10.3-131.9zM232 336V176l142.7 80L232 336z"
    />
  </svg>
</li>

</ul>

</div>

  )
}

export default LogoCard
